import React, { Component } from 'react';
import { MailIcon, UserIcon, AtSignIcon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
export function DataDeletion() {
  const email = 'realenlinea1@gmail.com';
  const subject = 'Eliminación de datos';
  const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  return <main className="w-full min-h-full bg-slate-50 text-slate-900" data-id="element-12">
      <div className="max-w-3xl mx-auto px-6 py-16 sm:py-20" data-id="element-13">
        <header className="mb-10" data-id="element-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-medium mb-4" data-id="element-15">
            <ShieldCheckIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-16" />
            Privacidad y Datos
          </div>
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900" data-id="element-17">
            Eliminación de Datos
          </h1>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed" data-id="element-18">
            Si deseas solicitar la eliminación de tus datos personales
            registrados por{' '}
            <span className="font-medium text-slate-900" data-id="element-19">Real en línea</span>,
            puedes hacerlo enviando un correo a{' '}
            <a href={mailto} className="font-medium text-emerald-700 underline underline-offset-2 hover:text-emerald-800" data-id="element-20">
              {email}
            </a>{' '}
            con el asunto{' '}
            <span className="font-medium text-slate-900" data-id="element-21">
              "Eliminación de datos"
            </span>
            .
          </p>
        </header>

        <section aria-labelledby="requisitos-titulo" className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 shadow-sm" data-id="element-22">
          <h2 id="requisitos-titulo" className="text-lg font-semibold text-slate-900 mb-5" data-id="element-23">
            En tu solicitud, por favor incluye:
          </h2>
          <ul className="space-y-4" data-id="element-24">
            <li className="flex items-start gap-3" data-id="element-25">
              <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center" data-id="element-26">
                <UserIcon className="w-4 h-4" aria-hidden="true" data-id="element-27" />
              </span>
              <div data-id="element-28">
                <p className="font-medium text-slate-900" data-id="element-29">Nombre completo</p>
                <p className="text-sm text-slate-600" data-id="element-30">
                  Tal como aparece en tu registro.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-31">
              <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center" data-id="element-32">
                <AtSignIcon className="w-4 h-4" aria-hidden="true" data-id="element-33" />
              </span>
              <div data-id="element-34">
                <p className="font-medium text-slate-900" data-id="element-35">Correo electrónico</p>
                <p className="text-sm text-slate-600" data-id="element-36">
                  El usado en el registro o compra.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-37">
              <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center" data-id="element-38">
                <FileTextIcon className="w-4 h-4" aria-hidden="true" data-id="element-39" />
              </span>
              <div data-id="element-40">
                <p className="font-medium text-slate-900" data-id="element-41">
                  Detalle de la solicitud
                </p>
                <p className="text-sm text-slate-600" data-id="element-42">
                  Describe qué datos deseas eliminar o anonimizar.
                </p>
              </div>
            </li>
          </ul>

          <div className="mt-8 pt-6 border-t border-slate-100" data-id="element-43">
            <a href={mailto} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2" data-id="element-44">
              <MailIcon className="w-4 h-4" aria-hidden="true" data-id="element-45" />
              Enviar solicitud por correo
            </a>
          </div>
        </section>

        <section className="mt-8 space-y-4 text-slate-600 leading-relaxed" data-id="element-46">
          <p data-id="element-47">
            Revisaremos tu solicitud y responderemos dentro de un plazo
            razonable conforme a la normativa aplicable.
          </p>
          <p data-id="element-48">
            Si la solicitud aplica, eliminaremos o anonimizaremos tus datos
            personales, salvo aquellos que debamos conservar por motivos
            legales, fiscales, administrativos o de seguridad.
          </p>
        </section>

        <footer className="mt-12 pt-6 border-t border-slate-200 text-xs text-slate-500" data-id="element-49">
          © {new Date().getFullYear()} Real en línea. Todos los derechos
          reservados.
        </footer>
      </div>
    </main>;
}